const widgetsToPrefetchOnInit = require('./templates_preload/widgets_templates_on_init');
const widgetsToPrefetchByPage = require('./templates_preload/widget_templates_prefetch_by_page');
const widgetResourceManager = require('./widget_resource_manager');
const templatesWithoutVariable = [
    'ancillaries_module',
    'collapsible_flight_summary',
    'edit_option_meta',
    'get_your_guide',
    'nag',
    'results_load_more',
    'shared_legal_disclaimer',
    'share_itinerary',
    'time_budget',
    'time_ranges_filter',
];

const parseStaticResources = (rawStaticTemplates) => {
    const staticTemplatesKeys = {};
    return Odigeo._.reduce(rawStaticTemplates, function(staticTemplates, templateData, name) {
        staticTemplates[name] = templateData.templates;
        staticTemplatesKeys[name] = templateData.keys;
        return staticTemplates;
    }, {getStaticTemplatesKeys: (templateName) => Odigeo._.get(staticTemplatesKeys, templateName, {})});
};

const parseResourceData = (templatesData) => {
    const templateSettings = Odigeo._.includes(templatesWithoutVariable, templatesData.name) ?
        {variable: ''} :
        {};
    const templates = Odigeo._.reduce(templatesData.templates, function(rawtemplates, template) {
        rawtemplates[template.name] = Odigeo._.template(template.html, Odigeo.Utils.getTmplSettings(templateSettings));
        return rawtemplates;
    }, {});
    const keys = Odigeo._.reduce(templatesData.cmsKeys, function(rawkeys, keyData) {
        rawkeys[keyData.name] = keyData.value;
        return rawkeys;
    }, {});
    return {
        keys: keys,
        templates: templates,
    };
};

const publicApi = {
    getWidgetResources: 'getWidgetTemplate',
    getListOfWidgetsResources: 'getListOfWidgetsTemplates',
    preloadNextWidgetResources: 'preloadNextWidgetTemplates',
    getGenericResources: 'getGenericTemplates',
    removeWidgetResource: 'removeWidgetResource',
};

module.exports = widgetResourceManager({
    getUrlService() {
        return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('templatesUrlPrefix');
    },
    getSessionScope() {
        return Odigeo.SessionScope;
    },
    parseResourceData,
    parseStaticResources,
    widgetsToPrefetchOnInit,
    widgetsToPrefetchByPage,
    resourceType: 'templates',
    hasStaticResources: true,
    publicApiConfig: publicApi,
},
publicApi);
